import { useMemo, useRef } from "react"

export const useHorizontalScrollable = () => {
    const scrollViewRef = useRef(null)

    const props = useMemo(
        () => ({
            ref: scrollViewRef,
            horizontal: true,
            showsHorizontalScrollIndicator: false,
        }),
        []
    )

    const scrollToCard = ({ cardWidth, index }) => {
        if (!scrollViewRef.current) return
        const x = index * cardWidth
        scrollViewRef.current.scrollTo({ x: x, animated: true })
    }

    return { props, scrollViewRef, scrollToCard }
}
